import Component from "@glimmer/component"
import type { GroupMembership } from "@shared/models/group"

interface Signature {
  Args: {
    row: GroupMembership
  }
}

export default class GroupMembersTableNameCell extends Component<Signature> {}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Group::MembersTable::Cells::Name": typeof GroupMembersTableNameCell
  }
}
